import { validateBillPay as uiValidateBillPay } from "../services/billpay.service";
import { useSessionStore } from "../../../state/src/useSessionStore";

export type BillPayValidationPayload = {
  unitProfileID: string | null;
  agentID: string | null;
  productVariant: 'EP';
  amount: number;
  destinationCountry: 'USA';
  receiveCode?: string;
  receiveAgentID?: string;
  billerAccountNumber?: string | null;
  senderFirstName?: string | null;
  senderLastName?: string | null;
  senderAddress?: string | null;
  senderCity?: string | null;
  senderState?: string | null;
  senderZipCode?: string | null;
  senderCountry: 'USA';
  senderHomePhone?: string | null;
  senderDOB?: string | undefined;
  accountNumberRetryCount: number;
  sendCurrency: 'USD';
  receiveCurrency: 'USD';
  cardSwiped: boolean;
  mgiTransactionSessionID?: string | undefined;
  formFreeStaging: boolean;
  consumerId?: string | undefined;
  consumerProfileUpdate: boolean;
  profilePreferenceId?: string | undefined;
  panAvailable: boolean;
};

export const buildBillPayValidationPayload = (args: BillPayValidationPayload): BillPayValidationPayload => {
  const merged = { ...args } as any;
  try {
    // Merge any additional information values from store (like send flow)
    const state: any = useSessionStore.getState();
    const extras: Record<string, any> = state?.additionalFieldValues || {};
    const existingKeys = Object.keys(merged);
    for (const key of Object.keys(extras)) {
      const value = extras[key];
      const exact = existingKeys.find(k => k === key);
      if (exact) {
        merged[exact] = value;
        continue;
      }
      const ci = existingKeys.find(k => k.toLowerCase() === key.toLowerCase());
      if (ci) {
        merged[ci] = value;
      } else {
        merged[key] = value;
      }
    }
  } catch {}
  return merged as BillPayValidationPayload;
};

export const callValidateBillPay = async (payload: BillPayValidationPayload): Promise<any> => {
  return await uiValidateBillPay(payload as any);
};


